import { HolderOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, Checkbox, Popover, Tooltip } from 'antd';
import { useState } from 'react';
import ReactDragListView from 'react-drag-listview';

import './columnSettings.less';

/**
 * Gear товч — дарахад баганыг нуух/харуулах, drag хийж байр солих dropdown
 * гарна. Props-ыг useColumnSettings-ийн `settingsProps`-оос шууд дамжуулна.
 */
const ColumnSettings = ({ items, isCustomized, onToggle, onMove, onReset }) => {
  const [open, setOpen] = useState(false);
  const visibleCount = items.filter((item) => item.visible).length;

  const content = (
    <div className="pp-column-settings">
      <div className="pp-column-settings__header">
        <span>Багана тохируулах</span>
        <Button type="link" size="small" disabled={!isCustomized} onClick={onReset}>
          Сэргээх
        </Button>
      </div>
      <ReactDragListView
        nodeSelector=".pp-column-settings__item"
        handleSelector=".pp-column-settings__handle"
        lineClassName="pp-column-settings__drag-line"
        onDragEnd={onMove}
      >
        <ul className="pp-column-settings__list">
          {items.map((item) => (
            <li key={item.key} className="pp-column-settings__item">
              <HolderOutlined className="pp-column-settings__handle" />
              <Checkbox
                checked={item.visible}
                // Хүснэгт хоосон үлдэхгүйн тулд сүүлийн харагдах баганыг нуухгүй
                disabled={item.visible && visibleCount === 1}
                onChange={(e) => onToggle(item.key, e.target.checked)}
              >
                {item.label}
              </Checkbox>
            </li>
          ))}
        </ul>
      </ReactDragListView>
    </div>
  );

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      arrow={false}
      open={open}
      onOpenChange={setOpen}
      content={content}
      overlayInnerStyle={{ padding: 0 }}
    >
      <Tooltip title="Багана тохируулах" open={open ? false : undefined}>
        <Button icon={<SettingOutlined />} />
      </Tooltip>
    </Popover>
  );
};

export default ColumnSettings;
